/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TransactionDetail } from './TransactionDetail';
import {
    TransactionDetailFromJSON,
    TransactionDetailFromJSONTyped,
    TransactionDetailToJSON,
} from './TransactionDetail';

/**
 * 
 * @export
 * @interface TransactionDetailViewModel
 */
export interface TransactionDetailViewModel {
    /**
     * 
     * @type {Array<TransactionDetail>}
     * @memberof TransactionDetailViewModel
     */
    transactionDetails: Array<TransactionDetail>;
}

/**
 * Check if a given object implements the TransactionDetailViewModel interface.
 */
export function instanceOfTransactionDetailViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "transactionDetails" in value;

    return isInstance;
}

export function TransactionDetailViewModelFromJSON(json: any): TransactionDetailViewModel {
    return TransactionDetailViewModelFromJSONTyped(json, false);
}

export function TransactionDetailViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): TransactionDetailViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'transactionDetails': ((json['TransactionDetails'] as Array<any>).map(TransactionDetailFromJSON)),
    };
}

export function TransactionDetailViewModelToJSON(value?: TransactionDetailViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'TransactionDetails': ((value.transactionDetails as Array<any>).map(TransactionDetailToJSON)),
    };
}

